import { getGlobal } from 'reactn';

import Texts from '../constants/texts';
import moment from 'moment';
import chroma from "chroma-js";
import { createHash } from 'crypto';

const TODAY_STR = moment().format('YYYY-MM-DD');

const Utils = {
  generateMD5Hash: (input) => {
    return createHash('md5').update(input).digest('hex');
  },
  reduceObjects: (array) => {
    const keysToReturnEmpty = ['benchmark_asset_name'];

    return array.reduce((accumulator, item) => {
      Object.keys(item).forEach(key => {
        if (!keysToReturnEmpty.includes(key)) {
          accumulator[key] = (accumulator[key] || 0) + item[key];
        } else {
          accumulator[key] = "";
        }
      });
      return accumulator;
    }, {});
  },
  capitalize: (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  arrayAreEqual: (a, b) => {
    var i = a.length;
    if (i != b.length) return false;
    while (i--) { if (a[i] !== b[i]) return false; }
    return true;
  },
  keyOnTrue: (object) => {
    let foundKeys = Object.entries(object).find(([_key, value]) => value === true);
    return foundKeys && foundKeys[0]
  },
  generateRandomColorInPallete: (existingColors) => {
    // Convert the existing colors to Lab color space for better perceptual uniformity
    const labColors = existingColors.map(color => chroma(color).lab());

    // Compute the average Lab color values
    const avgLab = labColors.reduce((acc, color) => {
      acc[0] += color[0];
      acc[1] += color[1];
      acc[2] += color[2];
      return acc;
    }, [0, 0, 0]).map(val => val / labColors.length);

    // Generate a new color based on the average Lab color
    let newLabColor;
    let attempts = 100; // Incrementa el número de intentos para permitir más variaciones
    do {
      newLabColor = [
        avgLab[0] + (Math.random() - 0.5) * 30,  // Ajuste más amplio para el componente L
        Math.min(100, Math.max(-100, avgLab[1] + (Math.random() - 0.5) * 80)),  // Ajuste más amplio para el componente a
        Math.min(100, Math.max(-100, avgLab[2] + (Math.random() - 0.5) * 80))   // Ajuste más amplio para el componente b
      ];
      attempts--;
    } while (attempts > 0 && labColors.some(color => chroma.deltaE(color, newLabColor) < 20)); // Umbral de diferencia de color aumentado

    let newHexColor = chroma.lab(...newLabColor).hex();
    return newHexColor;
  },
  compareChanges: (prev, next) => {
    if(prev && next){
      // delete order key if exist...
      try { next.forEach(obj => delete obj.order) } catch { console.warn('Invalid forEach on next var.') }

      var prev_str = JSON.stringify(prev);
      var next_str = JSON.stringify(next);

      return next_str.localeCompare(prev_str) == 0;
    }
    return false;
  },
  areObjectsEqual: (prev, next) => {
    if(prev && next){
      for (let key of Object.keys(prev)) {
        if (!Utils.compareChanges(prev, next)) {
          return false;
        }
      }
      for (let key of Object.keys(next)) {
        if (!Utils.compareChanges(prev, next)) {
          console.log(key, prev, next);
          return false;
        }
      }
      return true
    }
    return false;
  },
  /**
   * Get first day of current month
   *
   * @param date_str String YYYY-MM-DD
   *
   * @returns String YYYY-MM-01
   */
  beginningOfMonth: (date_str = TODAY_STR) => {
    let date = moment(date_str);
    return date.date(1).format('YYYY-MM-DD')
  },
  /**
   * Get first day of current year
   *
   * @param date_str String YYYY-MM-DD
   *
   * @returns String YYYY-MM-01
   */
  beginningOfYear: (date_str = TODAY_STR) => {
    let date = moment(date_str);
    return date.startOf('year').format('YYYY-MM-DD')
  },
  /**
   * Add days to specific date
   *
   * @param date_str String YYYY-MM-DD
   * @param days Int
   *
   * @returns moment date
   */
  addDays: (date_str, days) => {
    let date = moment(date_str);
    return date.add(days, 'days');
  },
  /**
   * Format date from YYYY-MM-DD to 'Tue Sep 01 2020 00:00:00 GMT-0400 (hora estándar de Chile)'
   *
   * @param date_str String YYYY-MM-DD
   *
   * @return moment date
   */
  dateToApiFormat: (date_str = TODAY_STR) => {
    let date = moment(date_str);
    return date.toDate();
  },
  /**
   * Format date from YYYY-MM-DD to DD de MMMM, YYYY
   *
   * @param date_str String YYYY-MM-DD
   *
   * @returns String DD de MMMM, YYYY
   */
  dateToString: (date_str = TODAY_STR) => {
    let date = moment(date_str);
    return date.format('DD [de] MMMM, YYYY');
  },
  /**
   * Get time from date to HH:mm:ss
   *
   * @param date_str String YYYY-MM-DD
   *
   * @returns String HH:mm:ss
   */
  getTimeFromDate: (date_str) => {
    let date = moment(date_str);
    return date.format('HH:mm:ss');
  },
  /**
   * Format date from YYYY-MM-DD to DD/MM/YYYY
   *
   * @param date_str String YYYY-MM-DD
   *
   * @returns String DD/MM/YYYY
   */
  dateToShortString: (date_str = TODAY_STR) => {
    let date = moment(date_str);
    return date.format('DD/MM/YYYY');
  },
  /**
   * Convert date string tu Date format
   *
   * @param date_str String DD/MM/YYYY
   *
   * @returns Date
   */
  shortStringToDate: (date_str) => {
    return new Date(date_str.replace( /(\d{1,2})\/(\d{1,2})\/(\d{4})/, "$2/$1/$3"))
  },
  stringDateToTimestamp: (strDate) => {
    return new Date(strDate).getTime();
  },
  getQueryStringParams: (query, keyType = 'exact') => {
    var urlParams;
    var match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = query.substring(1)

    urlParams = {};
    while (match = search.exec(query)){
      if(keyType == 'camelcase'){
        var key = _toCamelCase(decode(match[1]));
        urlParams[key] = decode(match[2]);
      }
      else urlParams[decode(match[1])] = decode(match[2]);
    }
    return urlParams;
  },
  jsonToQueryString: (params) => {
    if (!Utils.isEmpty(params)) {
      let string = '?';
      for (const item in params) {
        string += `${item}=${params[item]}&`
      }
      return string;
    }
    return "";
  },
  dynamicSort: (property, opts = {}) => {
    var sortOrder = 1;
    if(property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a,b) {
      // Get the values to compare
      let aValue = a[property];
      let bValue = b[property];
      
      if (opts.format === 'number' || opts.format === 'monetary' || opts.format === 'percentage') {
        aValue = aValue === null || aValue === undefined ? 0 : Number(aValue);
        bValue = bValue === null || bValue === undefined ? 0 : Number(bValue);
      }
      
      var result = 0;
      if (opts.absolute) {
        result = (Math.abs(aValue) < Math.abs(bValue)) ? -1 : (Math.abs(aValue) > Math.abs(bValue)) ? 1 : 0;
      } else if (opts.sortBy) {
        result = (a[opts.sortBy] < b[opts.sortBy]) ? -1 : (a[opts.sortBy] > b[opts.sortBy]) ? 1 : 0;
      } else {
        result = (aValue < bValue) ? -1 : (aValue > bValue) ? 1 : 0;
      }
      return result * sortOrder;
    }
  },
  toCamelCase: (a, b) => { return _toCamelCase(a, b) },
  toSnakeCase: (a) => { return _toSnakeCase(a) },
  // Validates that the input string is a valid date formatted as "dd/mm/yyyy"
  // credits: Elian Ebbing, stack overflow.
  isValidDate: (dateString) => {
    // First check for the pattern
    if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
      return false;

    // Parse the date parts to integers
    var parts = dateString.split("/");
    var day = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if(year < 1000 || year > 3000 || month == 0 || month > 12)
      return false;

    var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

    // Adjust for leap years
    if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
      monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  },
  getClientName: () => {
    var name = process.env.CLIENT_NAME;
    // Set default as QA.
    if(!name) return 'qa';

    // Puts '_' before the name, in case the string starts with a digit.
    if(name.charAt(0) >= '0' && name.charAt(0) <= '9') return '_' + name;

    // If the code execution reach this point, the name in CLIENT_NAME should be fine.
    return name;
  },
  /**
   * Separate number with commas
   */
  numberWithCommas: (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  numberToPercentage: (number, decimals = 0) => {
    return (number * 100).toFixed(decimals) + ' %';
  },
  /**
   * Validate if is number
   */
  isNumber: (input) => {
    if (typeof input !== 'number') {
      return false
    }
    if (input !== Number(input)) {
      return false
    }
    if (input === Infinity || input === !Infinity) {
      return false
    }
    return true
  },
  /**
   * Delete items duplicated from object's array
   *
   * @param name name params inside object is required
   */
  deleteDuplicatedFromObjectsArrayByName: (array) => {
    let arrayAux = [];
    for (let i = 0; i < array.length; i++) {
      if (arrayAux.length === 0) arrayAux.push(array[i]);
      else {
        let exist = false;
        for (let j = 0; j < arrayAux.length; j++) {
          if (arrayAux[j].name === array[i].name) {
            exist = true;
          }
        }
        if (!exist) arrayAux.push(array[i]);
      }
    }
    return arrayAux;
  },
  /**
   * Clone array or object
   *
   * @param array or object
   */
  cloneArray: (array) => {
    return JSON.parse(JSON.stringify(array));
  },
  /**
   * Validate condition
   *
   * @param firstValue
   * @param secondValue
   * @param operator
   * @param format
   */
  validateOperation: (firstValue, secondValue, operator, format = null) => {
    if (format === 'date') {
      if (operator === '>') return Utils.shortStringToDate(firstValue) > secondValue
      else if (operator === '>=') return Utils.shortStringToDate(firstValue) >= secondValue
      else if (operator === '==') return Utils.shortStringToDate(firstValue) == secondValue
      else if (operator === '<=') return Utils.shortStringToDate(firstValue) <= secondValue
      else if (operator === '<') return Utils.shortStringToDate(firstValue) < secondValue
      else return false;
    } else {
      if (operator === '>') return parseFloat(firstValue) > parseFloat(secondValue)
      else if (operator === '>=') return parseFloat(firstValue) >= parseFloat(secondValue)
      else if (operator === '==') return parseFloat(firstValue) == parseFloat(secondValue)
      else if (operator === '<=') return parseFloat(firstValue) <= parseFloat(secondValue)
      else if (operator === '<') return parseFloat(firstValue) < parseFloat(secondValue)
      else return false;
    }
  },
  /**
   * Check if exist object inside object's array
   *
   * @param Object obj
   * @param Array array
   */
  checkIfObjectExist: (obj, array, field = null) => {
    if (field) {
      if (array.find(element => element[field] == obj[field])) return true
    } else {
      for (let i = 0; i < array.length; i++) {
        if (array[i] == obj) return true
      }
    }
    return false;
  },
  /**
   * Convert array of objects to one object
   *
   * @param Array array
   */
  flattenObjects: (array) => {
    if (Array.isArray(array)) {
      return array.reduce((acc, obj) => {
        if (obj) return { ...acc, ...obj }
        else return acc
      }, {});
    }

    return array;
  },
  /**
   *
   * @param {*} color html color '#ffffff'
   * @param {*} amount % exchange
   * @returns other color with changes (lighten or darken)
   *
   */
  lighten: (color, amount) => {
    color = (color.indexOf("#") >= 0) ? color.substring(1, color.length) : color;
    amount = parseInt((255 * amount) / 100);
    return color = `#${addLight(color.substring(0, 2), amount)}${addLight(color.substring(2, 4), amount)}${addLight(color.substring(4, 6), amount)}`;
  },
  darken: (color, amount) => {
    color = (color.indexOf("#") >= 0) ? color.substring(1, color.length) : color;
    amount = parseInt((255 * amount) / 100);
    return color = `#${subtractLight(color.substring(0, 2), amount)}${subtractLight(color.substring(2, 4), amount)}${subtractLight(color.substring(4, 6), amount)}`;
  },

  /**
   * Remove duplicated on array
   */
  unique: (array) => {
    return array.filter((item, index, arr) => arr.indexOf(item) === index)
  },

  /**
   * Remove null params from object
   */
   removeNullFromObject: (object) => {
    return Object.fromEntries(Object.entries(object).filter(([_, v]) => v != null));
  },

  /**
   * Verify if object is empty
   */
  isEmpty: (object) => {
    return Object.keys(object).length === 0;
  },

  /**
   * Validate if set is empty. Using on SetRow and AssetRow component
   *
   * @param Object data
   * @returns boolean
   */
  isPadDataEmpty: (data) => {
    if (!data) return false;
    return Math.abs(data.start_amount) < 0.01 &&
           Math.abs(data.end_amount) < 0.01 &&
           Math.abs(data.utility) < 0.01 &&
           (!data.remaining_commitment || Math.abs(data.remaining_commitment) < 0.01)
  },

  /**
   * Extract only letters from string
   *
   * @param String str
   * @returns string (only letters)
   */
  extractOnlyLetters: (str) => {
    return str.replace(/[0-9]+/g, "");
  },

  /**
   * Extract only numbers from string
   *
   * @param String str
   * @returns string (only numbers)
   */
   extractOnlyNumbers: (str) => {
    return str.replace(/[^0-9]+/g, "");
  },

  /**
   * 
   * @param String str 
   * @param Integer num 
   * @returns str sliced by num
   */
  truncateString: (str, num) => {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + '...';
  },

  isAdmin: (user) => {
    return user.role == 'nivel1'
  },

  /**
   * Download file
   *
   * @param string path
   * @param string name
   */
  downloadPdf: (path, name) => {
    const linkSource = `data:application/pdf;base64,${path}`;
    const downloadLink = document.createElement("a");
    const fileName = `${name}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  },
  isSubset: (subsetArray, mainArray) => {
    return subsetArray.every((element) => mainArray.includes(element));
  },
  sentTimeAgoText: (date) => {
    const now = moment();
    const sentTime = moment(date);
    const diffInMinutes = now.diff(sentTime, "minutes");
    const diffInHours = now.diff(sentTime, "hours");
    const diffInDays = now.diff(sentTime, "days");

    let timeAgo;

    if (diffInMinutes < 60) {
      timeAgo = diffInMinutes + " minuto" + (diffInMinutes > 1 ? "s" : "");
    } else if (diffInHours < 24) {
      timeAgo = diffInHours + " hora" + (diffInHours > 1 ? "s" : "");
    } else {
      timeAgo = diffInDays + " día" + (diffInDays > 1 ? "s" : "");
    }

    return `Enviado hace ${timeAgo} atrás`;
  },
  extractURLSFromString: (string) => {
    let regex = /(https?:\/\/[^\s]+)/g;
    return string.match(regex);
  },
  /**
   * 
   */
  parseReportDate: (params) => {
    let user = getGlobal().user
    if (user.realtime_prices && params.end_date && moment().diff(moment(params.end_date), 'days') == 0) {
      return {...params, end_date: moment(params.end_date).add(1, 'days').format('YYYY-MM-DD')}
    } else {
      return params
    }
  },
  /**
   * Filters data items excluding weekend days.
   *
   * @param {Array} data - The data array to filter, where each element is of the form [timestamp (in milisecond), value].
   * @returns {Array} - A new array that excludes items corresponding to weekend days.
   */
  filterOutWeekendsInArrayOfArrays: (data) => {
    return data.filter(item => ![0, 6].includes(moment.unix(item[0] / 1000).utcOffset(0).day()));
  },
  isUndefined: (input) => {
    return input === undefined
  }
}

/**
 * Convert string from underscore separeted to camelcase
 *
 * @param string string
 *
 * @returns string
 */
const _toCamelCase = (string) => {
  return string.replace(/_([a-z])/g, g => g[1].toUpperCase());
}

/**
 * Converts a given camelCase or PascalCase string to snake_case.
 *
 * @param {string} str - The string to be converted. It should be in camelCase or PascalCase format.
 * @returns {string} - The converted string in snake_case format.
 */
const _toSnakeCase = str => str[0].toLowerCase() + str.slice(1, str.length).replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

const addLight = function(color, amount){
  let cc = parseInt(color, 16) + amount;
  let c = (cc > 255) ? 255 : (cc);
  c = (c.toString(16).length > 1 ) ? c.toString(16) : `0${c.toString(16)}`;
  return c;
}

const subtractLight = function(color, amount){
  let cc = parseInt(color, 16) - amount;
  let c = (cc < 0) ? 0 : (cc);
  c = (c.toString(16).length > 1 ) ? c.toString(16) : `0${c.toString(16)}`;
  return c;
}

export default Utils;
